/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender wizard client side functions
-----------------------------------------------------------------------------*/


var TECL_CheckoutGeneral = {

    // Clear all the error text lines
    ClearErrorTextLines: function() {
        // Reset all error fields
        $(".field-validation-error").each(function() {
            $(this).addClass("hidden");
        });
    },

};

var TECL_CheckoutMyDetails = {

    // Change radio button update 
    RadioButtonSelection: function(selectionId) {

        switch (selectionId) {
            case 1:
                {
                    // Make only the create account controls are shown
                    $("#signInSection").addClass("hidden");
                    $("#createAccountSection").removeClass("hidden");
                    $("#guestAccountSection").addClass("hidden");

                    // Clear any view info under Guest Account and reset the dropdown to please select
                    $("#ddlGuestAccountWebAccountList").data("kendoDropDownList").select(0);
                    $("#GuestAccountInput").empty();
                    break;
                }
            case 2:
                {
                    // Make only the guest account controls are shown
                    $("#signInSection").addClass("hidden");
                    $("#createAccountSection").addClass("hidden");
                    $("#guestAccountSection").removeClass("hidden");

                    // Clear any view info under Create Account and reset the dropdown to please select
                    $("#ddlCreateAccountWebAccountList").data("kendoDropDownList").select(0);
                    $("#CreateAccountInput").empty();
                    break;
                }
            default:
                {
                    // Make only the sign in controls are shown
                    $("#signInSection").removeClass("hidden");
                    $("#createAccountSection").addClass("hidden");
                    $("#guestAccountSection").addClass("hidden");

                    // Clear any view info under Create Account and reset the dropdown to please select
                    $("#ddlCreateAccountWebAccountList").data("kendoDropDownList").select(0);
                    $("#CreateAccountInput").empty();

                    // Clear any view info under Guest Account and reset the dropdown to please select
                    $("#ddlGuestAccountWebAccountList").data("kendoDropDownList").select(0);
                    $("#GuestAccountInput").empty();

                    break;
                }
        }
    },

    // Handle the web account user type change
    CreateAccountWebAccountUserTypeChange: function(e) {
        var webAccountUserTypeId = e.dataItem.Value;

        if (webAccountUserTypeId) {
            if (TECL_Master.AddLock("CreateAccountWebAccountList")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/CreateAccountAccountView",
                    type: "POST",
                    data: {
                        webAccountUserTypeId: webAccountUserTypeId
                    },
                    beforeSend: function() {
                        TECL_TenderGeneral.DisplayPleaseWaitDlg();
                    },
                    error: function(exc) {
                        TECL_TenderGeneral.HidePleaseWaitDlg();
                        TECL_Master.ClearLock("CreateAccountWebAccountList");
                    },
                    success: function(partialViewHtml) {
                        TECL_TenderGeneral.HidePleaseWaitDlg();
                        TECL_Master.ClearLock("CreateAccountWebAccountList");
                        if (partialViewHtml) {
                            $("#CreateAccountInput").html(partialViewHtml);
                            $("#CreateAccountInput").removeClass("hidden");
                        } else {
                            $("#CreateAccountInput").empty();
                            $("#CreateAccountInput").addClass("hidden");
                        }
                    }
                });
            }
        } else {
            $("#CreateAccountInput").empty();
            $("#CreateAccountInput").addClass("hidden");
        }
    },

    // Handle the web account user type change
    GuestAccountWebAccountUserTypeChange: function(e) {
        var webAccountUserTypeId = e.dataItem.Value;

        if (webAccountUserTypeId) {
            if (TECL_Master.AddLock("GuestAccountWebAccountList")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/GuestAccountAccountView",
                    type: "POST",
                    data: {
                        webAccountUserTypeId: webAccountUserTypeId
                    },
                    beforeSend: function() {
                        TECL_TenderGeneral.DisplayPleaseWaitDlg();
                    },
                    error: function(exc) {
                        TECL_TenderGeneral.HidePleaseWaitDlg();
                        TECL_Master.ClearLock("GuestAccountWebAccountList");
                    },
                    success: function(partialViewHtml) {
                        TECL_TenderGeneral.HidePleaseWaitDlg();
                        TECL_Master.ClearLock("GuestAccountWebAccountList");
                        if (partialViewHtml) {
                            $("#GuestAccountInput").html(partialViewHtml);
                            $("#GuestAccountInput").removeClass("hidden");
                        } else {
                            $("#GuestAccountInput").empty();
                            $("#GuestAccountInput").addClass("hidden");
                        }
                    }
                });
            }
        } else {
            $("#GuestAccountInput").empty();
            $("#GuestAccountInput").addClass("hidden");
        }
    },

    // Do a school search
    SchoolSearch: function() {

        var orgNameSearchText = null;
        var schoolSearchOrgNameInput = $("#schoolSearchOrgName");
        if (schoolSearchOrgNameInput.length > 0) {
            orgNameSearchText = schoolSearchOrgNameInput.val();
        }

        var townSearchText = null;
        var schoolSearchTownInput = $("#schoolSearchTown");
        if (schoolSearchTownInput.length > 0) {
            townSearchText = schoolSearchTownInput.val();
        }

        var postcodeSearchText = null;
        var schoolSearchPostcodeInput = $("#schoolSearchPostcode");
        if (schoolSearchPostcodeInput.length > 0) {
            postcodeSearchText = schoolSearchPostcodeInput.val();
        }

        var countryId = null;
        var schoolSearchCountryDropDown = $("#ddlSchoolSearchCountry");
        if (schoolSearchCountryDropDown.length > 0) {
            countryId = schoolSearchCountryDropDown.val();
        }

        var webAccountUserTypeId = TECL_CheckoutMyDetails.GetWebAccountUserTypeId();

        if (TECL_Master.AddLock("GenericCheckoutSchoolSearch")) {
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/SearchOrganisation",
                type: "POST",
                data: {
                    orgNameSearchText: orgNameSearchText,
                    postcodeSearchText: postcodeSearchText,
                    townSearchText: townSearchText,
                    webAccountUserTypeId: webAccountUserTypeId,
                    countryId: countryId
                },
                beforeSend: function() {
                    TECL_TenderGeneral.DisplayPleaseWaitDlg();
                },
                error: function(exc) {
                    TECL_TenderGeneral.HidePleaseWaitDlg();
                    TECL_Master.ClearLock("GenericCheckoutSchoolSearch");
                },
                success: function(partialViewHtml) {
                    TECL_TenderGeneral.HidePleaseWaitDlg();
                    TECL_Master.ClearLock("GenericCheckoutSchoolSearch");

                    if (partialViewHtml) {
                        $("#orgSearchResults").html(partialViewHtml);
                        $("#orgSearchResults").removeClass("hidden");
                    } else {
                        $("#orgSearchResults").empty();
                        $("#orgSearchResults").addClass("hidden");
                    }
                }
            });
        }
    },

    // Show the manual search controls
    ShowManualAddition: function() {
        $("#myDetailsSchoolSearch").addClass("hidden");
        $("#myDetailsSchoolAddManually").removeClass("hidden");
    },

    // Hide the manual search controls
    HideManualAddition: function() {
        $("#myDetailsSchoolAddManually").addClass("hidden");
        $("#myDetailsSchoolSearch").removeClass("hidden");
    },

    // Do a PAF search for an address
    AddressSearch: function() {
        var searchText = $("#createAccountAddressSearch").val();

        if (TECL_Master.AddLock("GenericCheckoutAddressSearch")) {
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/SearchAddresses",
                type: "POST",
                data: {
                    searchText: searchText
                },
                beforeSend: function() {
                    TECL_TenderGeneral.DisplayPleaseWaitDlg();
                },
                error: function(exc) {
                    TECL_TenderGeneral.HidePleaseWaitDlg();
                    TECL_Master.ClearLock("GenericCheckoutAddressSearch");
                },
                success: function(partialViewHtml) {
                    TECL_TenderGeneral.HidePleaseWaitDlg();
                    TECL_Master.ClearLock("GenericCheckoutAddressSearch");

                    if (partialViewHtml) {
                        $("#addressSearchResults").html(partialViewHtml);
                        $("#addressSearchResults").removeClass("hidden");
                    } else {
                        $("#addressSearchResults").empty();
                        $("#addressSearchResults").addClass("hidden");
                    }
                }
            });
        }
    },

    // Get the selected address data and show it on screen
    AddressSelected: function(e) {
        var addressKey = e.dataItem.Value;

        if (addressKey) {
            if (TECL_Master.AddLock("GenericCheckoutAddressSelected")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/GetFullAddress",
                    type: "POST",
                    data: {
                        addressKey: addressKey
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("GenericCheckoutAddressSelected");
                    },
                    success: function(addressData) {
                        TECL_Master.ClearLock("GenericCheckoutAddressSelected");

                        if (addressData) {
                            $("#createAccountAddressLine1").val(addressData.AddressLine1);
                            $("#createAccountAddressLine2").val(addressData.AddressLine2);
                            $("#createAccountAddressLine3").val(addressData.AddressLine3);
                            $("#createAccountTown").val(addressData.Town);
                            $("#createAccountCounty").val(addressData.CountyName);
                            $("#createAccountPostcode").val(addressData.Postcode);
                            $("#addressGridEast").val(addressData.GridEast);
                            $("#addressGridNorth").val(addressData.GridNorth);
                            $("#addressLatitude").val(addressData.Latitude);
                            $("#addressLongitude").val(addressData.Longitude);
                            $("#addressLeaCode").val(addressData.LeaCode);

                            if (addressData.CountryId) {
                                $("#ddlCreateAccountManuallyCountry").data("kendoDropDownList").value(addressData.CountryId);
                            }
                        } else {
                            $("#createAccountAddressLine1").val("");
                            $("#createAccountAddressLine2").val("");
                            $("#createAccountAddressLine3").val("");
                            $("#createAccountTown").val("");
                            $("#createAccountCounty").val("");
                            $("#createAccountPostcode").val("");
                            $("#addressGridEast").val("");
                            $("#addressGridNorth").val("");
                            $("#addressLatitude").val("");
                            $("#addressLongitude").val("");
                            $("#addressLeaCode").val("");
                            $("#ddlCreateAccountManuallyCountry").data("kendoDropDownList").value("");
                        }
                    }
                });
            }
        } else {
            $("#createAccountAddressLine1").val("");
            $("#createAccountAddressLine2").val("");
            $("#createAccountAddressLine3").val("");
            $("#createAccountTown").val("");
            $("#createAccountCounty").val("");
            $("#createAccountPostcode").val("");
            $("#addressGridEast").val("");
            $("#addressGridNorth").val("");
            $("#addressLatitude").val("");
            $("#addressLongitude").val("");
            $("#addressLeaCode").val("");
            $("#ddlCreateAccountManuallyCountry").data("kendoDropDownList").value("");
        }
    },

    // Authenticate the user
    AuthenticateUser: function() {
        var emailAddress = $("#signInEmailAddress").val();
        var password = $("#signInPassword").val();
        var rememberMe = document.getElementById("signInRememberMe").checked;

        $("#errIncorrectlogin").addClass("hidden");

        if (emailAddress && password) {
            if (TECL_Master.AddLock("GenericCheckoutAuthenticateUser")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/Authenticate",
                    type: "POST",
                    data: {
                        emailAddress: emailAddress,
                        password: password,
                        rememberMe: rememberMe
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("GenericCheckoutAuthenticateUser");
                    },
                    success: function(saveData) {
                        TECL_Master.ClearLock("GenericCheckoutAuthenticateUser");

                        if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                            window.location = saveData.NextStageUrl;
                        } else {
                            $("#errIncorrectlogin").removeClass("hidden");
                        }
                    }
                });
            }
        } else {
            $("#errIncorrectlogin").removeClass("hidden");
        }
    },

    // Create account continue button press
    CreateAccountContinue: function() {
        TECL_CheckoutGeneral.ClearErrorTextLines();
        var saveData = TECL_CheckoutMyDetails.GetAndValidateData();

        if (saveData) {
            if (TECL_Master.AddLock("GenericCheckoutCreateAccountContinue")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/SaveWebAccount",
                    type: "POST",
                    data: {
                        saveData: saveData
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("GenericCheckoutCreateAccountContinue");
                    },
                    success: function(saveData) {
                        TECL_Master.ClearLock("GenericCheckoutCreateAccountContinue");

                        if (saveData) {
                            if (saveData.Saved === true && saveData.NextStageUrl) {
                                window.location = saveData.NextStageUrl;
                            } else {
                                TECL_Master.ShowErrorDialog(saveData.ErrorDescription);
                            }
                        }
                    }
                });
            }
        }
    },

    // Get the data from the sign up process and validate it
    GetAndValidateData: function() {

        var firstNameResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountFirstName", "#errCreateAccountFirstName", null);
        var lastNameResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountLastName", "#errCreateAccountLastName", null);
        var emailAddressResultData = TECL_CheckoutMyDetails.GetControlEmailValueOrNull("#createAccountEmailAddress", "#errCreateAccountEmailAddress", "#createAccountEmailAddressConfirm", "#errCreateAccountEmailAddressConfirm");
        var passwordResultData = TECL_CheckoutMyDetails.GetControlPasswordValueOrNull("#createAccountPassword", "#errCreateAccountPassword", "#createAccountPasswordConfirm", "#errCreateAccountPasswordConfirm");
        var jobTitleResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountJobTitle", null, null);
        var jobTypeIdResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#ddlCreateAccountJobType", null, null);
        var organisationIdResultData = TECL_CheckoutMyDetails.GetControlOrganisationIdValueOrNull();
        var organisationNameResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountOrgName", "#errCreateAccountOrgName", "#myDetailsSchoolAddManually");
        var organisationTypeIdResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#ddlCreateAccountOrgType", "#errCreateAccountOrgType", "#myDetailsSchoolAddManually");
        var addressLine1ResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountAddressLine1", "#errCreateAccountAddressLine1", "#myDetailsSchoolAddManually");
        var addressLine2ResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountAddressLine2", null, "#myDetailsSchoolAddManually");
        var addressLine3ResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountAddressLine3", null, "#myDetailsSchoolAddManually");
        var townNameResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountTown", "#errCreateAccountTown", "#myDetailsSchoolAddManually");
        var countyNameResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountCounty", null, "#myDetailsSchoolAddManually");
        var countryIdResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#ddlCreateAccountManuallyCountry", "#errCreateAccountManuallyCountry", "#myDetailsSchoolAddManually");
        var postcodeResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAccountPostcode", "#errCreateAccountPostcode", "#myDetailsSchoolAddManually");
        var gridEastResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#addressGridEast", null, "#myDetailsSchoolAddManually");
        var gridNorthResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#addressGridNorth", null, "#myDetailsSchoolAddManually");
        var latitudeResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#addressLatitude", null, "#myDetailsSchoolAddManually");
        var longitudeResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#addressLongitude", null, "#myDetailsSchoolAddManually");
        var leaCodeResultData = TECL_CheckoutMyDetails.GetControlValueOrNull("#addressLeaCode", null, "#myDetailsSchoolAddManually");

        var isValid = true;

        if (!firstNameResultData.valid || !lastNameResultData.valid || !emailAddressResultData.valid || !passwordResultData.valid ||
             !organisationNameResultData.valid || !organisationTypeIdResultData.valid || !addressLine1ResultData.valid ||
            !townNameResultData.valid || !countryIdResultData.valid || !postcodeResultData.valid || !organisationIdResultData.valid) {
            isValid = false;
        }

        var saveData;
        if (isValid) {
            var isGuestAccount = TECL_CheckoutMyDetails.GetIsGuestAccount();
            var webAccountUserTypeId = TECL_CheckoutMyDetails.GetWebAccountUserTypeId();
            saveData = {
                IsGuestAccount: isGuestAccount,
                WebAccountUserTypeId: webAccountUserTypeId,
                FirstName: firstNameResultData.value,
                LastName: lastNameResultData.value,
                EmailAddress: emailAddressResultData.value,
                Password: passwordResultData.value,
                JobTitle: jobTitleResultData.value,
                JobTypeId: jobTypeIdResultData.value,
                OrganisationId: organisationIdResultData.value,
                OrganisationName: organisationNameResultData.value,
                OrganisationTypeId: organisationTypeIdResultData.value,
                AddressLine1: addressLine1ResultData.value,
                AddressLine2: addressLine2ResultData.value,
                AddressLine3: addressLine3ResultData.value,
                TownName: townNameResultData.value,
                CountyName: countyNameResultData.value,
                CountryId: countryIdResultData.value,
                Postcode: postcodeResultData.value,
                GridEast: gridEastResultData.value,
                GridNorth: gridNorthResultData.value,
                Latitude: latitudeResultData.value,
                Longitude: longitudeResultData.value,
                LeaCode: leaCodeResultData.value
            };
        } else {
            saveData = null;
        }
        return saveData;
    },

    // Get whether this is a guest account
    GetIsGuestAccount: function() {
        var isGuestAccount = false;

        var isGuestAccountValue = $("#myDetailsIsGuestAccount").val();
        if (isGuestAccountValue) {
            isGuestAccount = true;
        }

        return isGuestAccount;
    },

    // Get the web account type user id
    GetWebAccountUserTypeId: function() {
        var isGuestAccount = $("#myDetailsIsGuestAccount").val();
        var webAccountUserTypeId;
        if (isGuestAccount) {
            webAccountUserTypeId = $("#ddlGuestAccountWebAccountList").val();
        } else {
            webAccountUserTypeId = $("#ddlCreateAccountWebAccountList").val();
        }
        return webAccountUserTypeId;
    },

    // Get the controls value else null also
    GetControlValueOrNull: function(cntrlNodeText, cntrlValidationNodeText, cntrlVisibilityDiv) {
        var valueCntrl = $(cntrlNodeText);
        var isValid = true;

        var isVisible = true;
        if (cntrlVisibilityDiv) {
            var visibilityDiv = $(cntrlVisibilityDiv);
            isVisible = false;

            if (visibilityDiv.length > 0) {
                isVisible = !visibilityDiv.hasClass("hidden");
            }
        }

        var value;
        if (valueCntrl.length > 0 && isVisible) {
            value = valueCntrl.val();

            if (!value) {
                isValid = false;
            }

            if (cntrlValidationNodeText) {
                var validateCntrl = $(cntrlValidationNodeText);
                if (validateCntrl.length > 0) {
                    if (isValid) {
                        validateCntrl.addClass("hidden");
                    } else {
                        validateCntrl.removeClass("hidden");
                    }
                }
            }
        } else {
            value = null;
        }

        return { valid: isValid, value: value };
    },

    // Validate the organisation control
    GetControlOrganisationIdValueOrNull: function() {
        var organisationId = null;
        var isValid = true;

        var searchOrgDiv = $("#myDetailsSchoolSearch");
        $("#errOrganisationSelection").addClass("hidden");

        if (searchOrgDiv.length > 0 && !searchOrgDiv.hasClass("hidden")) {
            // check org list if no org list false
            var searchOrgCntrl = $("#ddlOrganisations");

            if (searchOrgCntrl.length > 0) {
                organisationId = searchOrgCntrl.val();

                if (!organisationId) {
                    $("#errOrganisationSelection").removeClass("hidden");
                    isValid = false;
                }
            } else {
                isValid = false;
                $("#errOrganisationSelection").removeClass("hidden");
            }
        }
        return { valid: isValid, value: organisationId };
    },

    // Validate the email and compare email address controls
    GetControlEmailValueOrNull: function(cntrlNodeText, cntrlValidationNodeText, cntrlConfirmNodeText, cntrlConfirmValidationNodeText) {
        var isValid = true;
        var emailAddressValue = null;

        var emailResultData = TECL_CheckoutMyDetails.GetControlValueOrNull(cntrlNodeText, cntrlValidationNodeText, null);
        var emailConfirmResultData = TECL_CheckoutMyDetails.GetControlValueOrNull(cntrlConfirmNodeText, cntrlConfirmValidationNodeText, null);

        if (emailResultData.valid && emailConfirmResultData.valid) {

            if (TECL_Master.IsEmailAddress(emailResultData.value)) {

                if (emailResultData.value === emailConfirmResultData.value) {
                    emailAddressValue = emailResultData.value;
                } else {
                    $(cntrlConfirmValidationNodeText).removeClass("hidden");
                    isValid = false;
                }
            } else {
                $(cntrlValidationNodeText).removeClass("hidden");
                isValid = false;
            }
        }
        return { valid: isValid, value: emailAddressValue };
    },

    // Validate the password and compare password controls
    GetControlPasswordValueOrNull: function(cntrlNodeText, cntrlValidationNodeText, cntrlConfirmNodeText, cntrlConfirmValidationNodeText) {
        var isValid = true;
        var passwordValue = "";

        var passwordResultData = TECL_CheckoutMyDetails.GetControlValueOrNull(cntrlNodeText, cntrlValidationNodeText, null);
        var passwordConfirmResultData = TECL_CheckoutMyDetails.GetControlValueOrNull(cntrlConfirmNodeText, cntrlConfirmValidationNodeText, null);

        var mainControl = $(cntrlNodeText);

        if (mainControl && mainControl.length > 0) {

            if (passwordResultData.valid && passwordConfirmResultData.valid) {

                if (passwordResultData.value && passwordResultData.value.length >= 5) {

                    if (passwordResultData.value === passwordConfirmResultData.value) {
                        passwordValue = passwordResultData.value;

                    } else {
                        $(cntrlConfirmValidationNodeText).removeClass("hidden");
                        isValid = false;
                    }
                } else {
                    $(cntrlValidationNodeText).removeClass("hidden");
                    isValid = false;
                }
            }
        }
        return { valid: isValid, value: passwordValue };
    }

};

var TECL_CheckoutDeliveryOptions = {

    // Handle other address change
    OtherAddressSelected: function(addressId) {
        if (addressId) {
            $("#manuallyAddAddressFields").addClass("hidden");
        } else {
            var orgNameCntrl = $("#createOrgName");
            if (orgNameCntrl && orgNameCntrl.length > 0) {
                $("#createOrgName").val("");
            }

            $("#createAddressLine1").val("");
            $("#createAddressLine2").val("");
            $("#createAddressLine3").val("");
            $("#createAddressTown").val("");
            $("#createAddressCounty").val("");
            $("#createAddressPostcode").val("");
            $("#ddlCreateAddressCountry").data("kendoDropDownList").select(0);

            $("#manuallyAddAddressFields").removeClass("hidden");
        }
    },

    // Get the other address data and validate it
    GetAndValidateOtherAddressData: function() {

        // Validate data
        var addressLine1Data = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAddressLine1", "#errCreateAddressLine1", "#manuallyAddAddressFields");
        var addressLine2Data = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAddressLine2", null, "#manuallyAddAddressFields");
        var addressLine3Data = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAddressLine3", null, "#manuallyAddAddressFields");
        var townData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAddressTown", "#errCreateAccountTown", "#manuallyAddAddressFields");
        var countyData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAddressCounty", null, "#manuallyAddAddressFields");
        var postcodeData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createAddressPostcode", "#errCreateAccountPostcode", "#manuallyAddAddressFields");
        var countryIdData = TECL_CheckoutMyDetails.GetControlValueOrNull("#ddlCreateAddressCountry", "#errCreateAddressCountry", "#manuallyAddAddressFields");

        // Get org name if displayed
        var orgNameValid = true;
        var orgNameValue = null;
        var orgNameCntrl = $("#createOrgName");
        if (orgNameCntrl && orgNameCntrl.length > 0) {
            var orgNameData = TECL_CheckoutMyDetails.GetControlValueOrNull("#createOrgName", "#errCreateOrgName");
            orgNameValid = orgNameData.valid;
            orgNameValue = orgNameData.value;
        }

        var isValid = orgNameValid && addressLine1Data.valid && townData.valid && postcodeData.valid && countryIdData.valid;

        var saveData;
        if (isValid) {
            saveData = {
                OrganisationName: orgNameValue,
                AddressLine1: addressLine1Data.value,
                AddressLine2: addressLine2Data.value,
                AddressLine3: addressLine3Data.value,
                TownName: townData.value,
                CountyName: countyData.value,
                Postcode: postcodeData.value,
                CountryId: countryIdData.value
            };
        } else {
            saveData = null;
        }
        return saveData;
    },

    // The continue button has been selected
    ContinueSelected: function() {

        TECL_CheckoutGeneral.ClearErrorTextLines();

        var saveData;
        var addressId;

        // If the other address is selected validate the manual address controls
        var deliveryAddressCheckedValue = $("input[name='deliveryAddress']:checked").val();
        if (deliveryAddressCheckedValue === "other") {
            saveData = TECL_CheckoutDeliveryOptions.GetAndValidateOtherAddressData();
            addressId = null;
        } else {
            saveData = null;
            addressId = deliveryAddressCheckedValue;
        }

        if (addressId || saveData) {
            if (TECL_Master.AddLock("CheckoutDeliveryOptionsContinueSelected")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/SaveDeliveryAddress",
                    type: "POST",
                    data: {
                        saveData: saveData,
                        addressId: addressId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("CheckoutDeliveryOptionsContinueSelected");
                    },
                    success: function(saveData) {
                        TECL_Master.ClearLock("CheckoutDeliveryOptionsContinueSelected");

                        if (saveData) {
                            if (saveData.Saved === true && saveData.NextStageUrl) {
                                window.location = saveData.NextStageUrl;
                            } else {
                                TECL_Master.ShowErrorDialog(saveData.ErrorDescription);
                            }
                        }
                    }
                });
            }
        }
    }

};

var TECL_CheckoutBillingOptions = {

    // Handle other address change
    OtherAddressSelected: function(addressId) {
        if (addressId) {
            $("#manuallyAddAddressFields").addClass("hidden");
        } else {
            var orgNameCntrl = $("#createOrgName");
            if (orgNameCntrl && orgNameCntrl.length > 0) {
                $("#createOrgName").val("");
            }
            $("#createAddressLine1").val("");
            $("#createAddressLine2").val("");
            $("#createAddressLine3").val("");
            $("#createAddressTown").val("");
            $("#createAddressCounty").val("");
            $("#createAddressPostcode").val("");
            $("#ddlCreateAddressCountry").data("kendoDropDownList").select(0);

            $("#manuallyAddAddressFields").removeClass("hidden");
        }
    },

    // The continue button has been selected
    ContinueSelected: function() {
        TECL_CheckoutGeneral.ClearErrorTextLines();

        var saveData;
        var addressId;

        // If the other address is selected validate the manual address controls
        var billingAddressCheckedValue = $("input[name='deliveryAddress']:checked").val();
        if (billingAddressCheckedValue === "other") {
            saveData = TECL_CheckoutDeliveryOptions.GetAndValidateOtherAddressData();
            addressId = null;
        } else {
            saveData = null;
            addressId = billingAddressCheckedValue;
        }

        if (saveData || addressId) {
            if (TECL_Master.AddLock("CheckoutBillingOptionsContinueSelected")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/SaveBillingAddress",
                    type: "POST",
                    data: {
                        saveData: saveData,
                        addressId: addressId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("CheckoutBillingOptionsContinueSelected");
                    },
                    success: function(saveData) {
                        TECL_Master.ClearLock("CheckoutBillingOptionsContinueSelected");

                        if (saveData) {
                            if (saveData.Saved === true && saveData.NextStageUrl) {
                                window.location = saveData.NextStageUrl;
                            } else {
                                TECL_Master.ShowErrorDialog(saveData.ErrorDescription);
                            }
                        }
                    }
                });
            }
        }
    }

};

var TECL_CheckoutPaymentOptions = {

    // The continue button has been selected
    ContinueSelected: function() {
        var isValid = true;

        TECL_CheckoutGeneral.ClearErrorTextLines();

        var purchaseOrderRef = $("#orderReference").val();

        // Get payment method id
        var paymentMethodId;
        var selectedPaymentControl = $("input[name='paymentMethod']:checked");
        if (selectedPaymentControl && selectedPaymentControl.length > 0) {
            paymentMethodId = selectedPaymentControl.val();
        } else {
            paymentMethodId = null;
        }

        if (!paymentMethodId) {
            $("#errPaymentMethod").removeClass("hidden");
            isValid = false;
        } else {
            $("#errPaymentMethod").addClass("hidden");
        }

        // Get postage option id
        var postageOptionId;
        var selectPostageControl = $("input[name='postageOption']:checked");
        if (selectPostageControl && selectPostageControl.length > 0) {
            postageOptionId = $("input[name='postageOption']:checked").val();
        } else {
            postageOptionId = null;
        }

        if (!postageOptionId && $("input[name='postageOption']").length > 0) {
            $("#errPostageSelections").removeClass("hidden");
            isValid = false;
        } else {
            $("#errPostageSelections").addClass("hidden");
        }

        if (isValid) {
            if (TECL_Master.AddLock("CheckoutPaymentOptionsContinueSelected")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/SavePaymentOptions",
                    type: "POST",
                    data: {
                        carriageId: postageOptionId,
                        paymentMethodId: paymentMethodId,
                        purchaseOrderRef: purchaseOrderRef
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("CheckoutPaymentOptionsContinueSelected");
                    },
                    success: function(saveData) {
                        TECL_Master.ClearLock("CheckoutPaymentOptionsContinueSelected");

                        if (saveData) {
                            if (saveData.Saved === true && saveData.NextStageUrl) {
                                window.location = saveData.NextStageUrl;
                            } else {
                                TECL_Master.ShowErrorDialog(saveData.ErrorDescription);
                            }
                        }
                    }
                });
            }
        }
    },

    // Get the selected postage data and update the basket total
    PostageChanged: function(e) {
        var carriageIdStr = e.dataItem.Value;
        if (TECL_Master.AddLock("GenericCheckoutPostageChanged")) {
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/UpdateBasketValue",
                type: "POST",
                data: {
                    carriageIdStr: carriageIdStr
                },
                error: function(exc) {
                    TECL_Master.ClearLock("GenericCheckoutPostageChanged");
                },
                success: function(partialViewHtml) {
                    TECL_Master.ClearLock("GenericCheckoutPostageChanged");

                    if (partialViewHtml) {
                        $("#CheckoutBasketTotalDiv").html(partialViewHtml);
                    }
                }
            });
        }
    }

};

var TECL_CheckoutCompletion = {

    // The register button has been selected
    Register: function() {
        var passwordResultData = TECL_CheckoutMyDetails.GetControlPasswordValueOrNull("#userPassword", "#errUserPassword", "#userConfirmPassword", "#errUserConfirmPassword");

        if (passwordResultData.valid && passwordResultData.value) {
            var webAccountId = $("#webAccountId").val();

            if (TECL_Master.AddLock("TECL_CheckoutCompletionRegister")) {
                $.ajax({
                    url: baseSiteUrl + "umbraco/Surface/GenericCheckoutSurface/MakeGuestAccountAFullAccount",
                    type: "POST",
                    data: {
                        password: passwordResultData.value,
                        webAccountId: webAccountId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TECL_CheckoutCompletionRegister");
                    },
                    success: function(resultData) {
                        TECL_Master.ClearLock("TECL_CheckoutCompletionRegister");
                        if (resultData) {
                            if (resultData.Saved === true) {
                                $("#registrationThankyouText").removeClass("hidden");
                                $("#guestRegistrationControls").addClass("hidden");
                            } else {
                                TECL_Master.ShowErrorDialog(resultData.ErrorDescription);
                            }
                        }
                    }
                });
            }
        }
    }

};
